import { PollType } from 'api/api.types';

export const isPoll = (type: PollType) => {
  return type === 'poll_simple' || type === 'poll_complex';
};
